import React from "react"
import { createRef } from "create-react-ref"

class Div100vh extends React.Component {
  constructor() {
    super()
    this.myRef = createRef()
    this.setHeightAsWindow = this.setHeightAsWindow.bind(this)
  }

  setHeightAsWindow() {
    const node = this.myRef.current
    node.style.height = window.innerHeight + `px`
  }

  componentDidMount() {
    this.setHeightAsWindow()
    window.addEventListener(`scroll`, this.setHeightAsWindow)
    window.addEventListener(`resize`, this.setHeightAsWindow)
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.setHeightAsWindow)
    window.removeEventListener(`resize`, this.setHeightAsWindow)
  }

  render() {
    return <div ref={this.myRef} {...this.props} />
  }
}

export default Div100vh
